$(document).ready(function(){
  $(document).on('click', '.popup--close-btn', function(){
    localStorage.setItem('newspophide', 'hide');
});
  // if (localStorage.getItem('wetheme-popup') && !localStorage.getItem('newspophide')) {
  //   // Show the alert
  //   setTimeout(function(){
  //   $('#popup').addClass('visible slide-up');
  // },2000);
  // }
  if (!localStorage.getItem('newspophide')) {
    // Show the alert
    setTimeout(function(){
    $('#popup').addClass('visible slide-up');
  },2000);
  }else {
    $('#popup').removeClass('visible slide-up');
  }
  // if (!localStorage.getItem('wetheme-popup')) {
  //   if (localStorage.getItem('newspophide')) {
  //   localStorage.removeItem('newspophide');
  // }
  // }
  $('.prd_star_reviews').click(function(){
    // alert("hello");
    $([document.documentElement, document.body]).animate({
        scrollTop: $("#judgeme_product_reviews .jdgm-widget-actions-wrapper").offset().top 
    }, 2000);
  });
  
  $(document).on('click','.custom_feature_product .checkout_btn',function(){ 
      //alert("clicked");
    var ID = $(this).attr("value"); 
    $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: ID
    },
      dataType: 'json', 
     success: function (data) { 
      window.location.href = '/checkout';
     
     } 
     });
   });

    $(document).on('click','.custom_feature_product .add_to_cart',function(){ 
      //alert("clicked");
    var ID = $(this).attr("value"); 
    $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: ID
    },
      dataType: 'json', 
     success: function (data) { 
      window.location.href = '/cart';
     
     } 
     });
   }); 


  // custom tabs section start

   $('#tabs-nav li:first-child').addClass('active');
    $('.tab-content').hide();
    $('.tab-content:first').show();
    
    // Click function
    $('#tabs-nav li').click(function(){
      $('#tabs-nav li').removeClass('active');
      $(this).addClass('active');
      $('.tab-content').hide();
      
      var activeTab = $(this).find('a').attr('href');
      $(activeTab).fadeIn();
      return false;
    });

  // custom tabs section end


  // bundle section start

   $(document).on('click', '.custom_bundle_swatches_box .swatches', function(){
     $(this).closest('.custom_bundle_swatches_box').find('.active').removeClass('active');
     $(this).addClass('active');
     
     var thisPrdId = $(this).attr('selected_prd_id');
     $(this).closest('.product_box').find('.custom_bnd_add_btn').attr('prd_id', thisPrdId);
  
     var prd = $(this).attr('prd');
     $(this).closest('.product_box').find('.image_box').each(function(){
       var imgPrd =  $(this).attr('prd');
       if(imgPrd == prd) {
          $(this).show();
       } else {
          $(this).hide();
       }
     })
   })

   $(document).on('click','.custom_bnd_add_btn',function(){ 
      //alert("clicked");
    var cartUrl = $(this).attr('store');
    var ID = $(this).attr("prd_id");
    var QTY = $(this).attr("qty"); 
    $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: QTY,
      id: ID
    },
      dataType: 'json', 
     success: function (data) { 
      window.location.href = cartUrl;
     } 
     });
   }); 
  
  // bundle section end
  
});

